import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import type { CreateDealReqBody, DealEntity } from '../../../apis/dealsAPI'
import { useApiErrorHandler } from '../../../hooks/useApiErrorHandler'
import { useToast } from '../../../hooks/useToast'

import { DEALS_QUERY_KEY_ROOT } from './useDealsQuery'

export function useCreateDealMutation(): UseMutationResult<DealEntity, unknown, CreateDealReqBody> {
  const queryClient = useQueryClient()
  const toast = useToast()
  const handleError = useApiErrorHandler()

  return useMutation<DealEntity, unknown, CreateDealReqBody>(
    (body) => dealsAPI.createDeal(body),
    {
      onSuccess: (deal) => {
        toast.current?.show({
          severity: 'success',
          summary: 'Deal created',
          detail: `Deal ${deal.orderNumber} added to the list.`,
          life: 3000,
        })
        queryClient.invalidateQueries({ queryKey: DEALS_QUERY_KEY_ROOT })
      },
      onError: handleError,
    },
  )
}
